import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivate, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { Home } from './screens/home/home.component';

const redirectUnauthorized = () => redirectUnauthorizedTo(['dang-nhap']);
const redirectLoggedIn = () => redirectLoggedInTo(['trang-chu']);

const routes: Routes = [
  // Các route auth
  {
    path: 'dang-nhap',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    ...canActivate(redirectLoggedIn),
  },
  { path: 'login', redirectTo: 'dang-nhap', pathMatch: 'full' },
  { path: 'dang-ky', redirectTo: 'dang-nhap', pathMatch: 'full' },

  // Trang chủ (không lazy load) - Public
  { path: '', component: Home, pathMatch: 'full' },
  { path: 'home', component: Home },

  // Payment Center - Chỉ cần đăng nhập
  {
    path: 'payment-center',
    loadComponent: () => import('./screens/payment-center/payment-center.component').then(m => m.PaymentCenterComponent),
    ...canActivate(redirectUnauthorized),
  },
  {
    path: 'payment-cancel',
    redirectTo: '/payment-center',
    pathMatch: 'full'
  },

  // Control Center - Chỉ cần đăng nhập
  {
    path: 'controlCenter',
    loadComponent: () => import('./screens/controlCenter/controlCenter.component').then(m => m.ControlCenter),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'food-management',
    loadComponent: () => import('./screens/food-management/food-management.component').then(m => m.FoodManagementComponent),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'mission-management',
    loadComponent: () => import('./screens/mission-management/mission-management.component').then(m => m.MissionManagementComponent),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'service-management',
    loadComponent: () => import('./screens/service-management/service-management.component').then(m => m.ServiceManagementComponent),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'price-editor',
    loadComponent: () => import('./screens/price-editor/price-editor.component').then(m => m.PriceEditorComponent),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'ad-management',
    loadComponent: () => import('./screens/ad-management/ad-management.component').then(m => m.AdManagementComponent),
    ...canActivate(redirectUnauthorized),
  },

  {
    path: 'ai-settings',
    loadComponent: () => import('./screens/ai-config/ai-config.component').then(m => m.AiConfigComponent),
    ...canActivate(redirectUnauthorized),
  },

  // Trang không có quyền truy cập
  {
    path: 'unauthorized',
    loadComponent: () => import('./components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },

  { path: 'trang-chu', redirectTo: '', pathMatch: 'full' },

  // Trang 404
  {
    path: '**',
    loadComponent: () => import('./components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
